<template>
    <table class="table">
        <thead class="thead-dark">
            <tr>
                <th v-for="(column, index) in columns" :key="index">
                    <slot :column="column">
                        {{ displayColumn(column) }}
                    </slot>
                </th>
            </tr>
        </thead>

        <tbody>
            <tr v-for="item in data" :key="item.id">
                <td
                    v-for="(column,index) in columns"
                    :key="index"
                    @click="onTdClick(item)"
                >
                    <slot :item="item" :column="column">
                        {{ displayValue(column, item) }}
                    </slot>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    import notEmpty from '@shared/validators/notEmpty';

    export default {
        name: 'Table',
        props: {
            columns: {
                type: Array,
                required: true,
                validator: notEmpty
            },
            data: {
                type: Array,
                required: false,
                default() {
                    return [];
                }
            },
            emptyValue: {
                type: String,
                required: false,
                default: '-'
            }
        },
        methods: {
            displayColumn(column) {
                return column.displayValue || column;
            },

            displayValue(column, item) {
                const key = column.key || column;
                return item[key].value || this.emptyValue;
            },
            onTdClick(item) {
                this.$emit('tdClick', item);
            }
        },
    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/app/modules/shared/components/Table.vue